<template>
  <div ref="elRef" class="flex flex-col w-full" @click="clickEvent">
    <div class="border-b border-black/[0.05] w-full my-4"></div>
    <div class="flex items-center gap-x-4">
      <OIcon :icon="`news-${index + 1}`" class="w-[31px] h-11" />
      <OLink
        v-if="article"
        class="text-primary-100 text-md font-medium leading-18 hover:text-link-primary"
        :href="getArticleUrl({ article })"
        v-bind="bind(article)"
        :title="article.title"
        @click="handleClickNews"
      >
        {{ article.title }}
      </OLink>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OImage, OLink, OIcon } from '~/modules/common/components/ui';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';
export default defineComponent({
  components: {
    OImage,
    OLink,
    OIcon,
  },
  props: {
    article: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  setup(props) {
    const { sendKesfetEvent } = onedioEvents();
    const { sendDataLayer } = useTracking();
    const { elRef, clickEvent } = sendDataLayer(
      {
        item: props.article,
        list: 'Keşfet - Neler Oluyor',
        position: 1,
        listId: 'Keşfet',
      },
      ['scroll', 'click']
    );

    const bind = (article) => {
      const params = {};
      if (article?.redirectUrl) {
        params.rel = 'nofollow';
      }
      return params;
    };

    const handleClickNews = () => {
      sendKesfetEvent('Sidebar', 'Click', 'Neler Oluyor');
    };

    return { elRef, clickEvent, getArticleUrl, bind, handleClickNews };
  },
});
</script>
